export function pickRecordProperty<T, U extends keyof T>(record: Record<string, T>, recordProperty: U): Record<string, T[U]> {
	const newRecord: Record<string, T[U]> = {};

	Object.keys(record).forEach((recordKey) => {
		newRecord[recordKey] = record[recordKey][recordProperty];
	});

	return newRecord;
}

export function removeEmptyPropertiesFromNestedObjects(obj: object) {
	const newObj = {};
	Object.keys(obj).forEach((key) => {
		if (obj[key] === Object(obj[key])) {
			newObj[key] = removeEmptyPropertiesFromNestedObjects(obj[key]);
		} else if (obj[key] !== undefined && obj[key] !== null) {
			newObj[key] = obj[key];
		}
	});
	return newObj;
}
